// extracted by mini-css-extract-plugin
export default {"expandTriangleIcon":"SubIssuesSummaryToken-module__expandTriangleIcon--xSUo8","SubIssuesSummaryToken":"SubIssuesSummaryToken-module__SubIssuesSummaryToken--JkzLS"};